import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Cascader } from 'antd';

const recursive = (array, valueKey, labelKey, childrenKey) => {
  const returnArray = array.map((entry) => {
    let children = [];
    if (entry[childrenKey]) {
      children = recursive(entry[childrenKey], valueKey, labelKey, childrenKey);
    }

    return {
      value: entry[valueKey],
      label: entry[labelKey],
      children,
    };
  });
  return returnArray;
};

const find = (array, number, accumilator) => {
  let result;
  let found = [...accumilator];
  for (let entry of array) {
    if (entry.value === number) {
      found = [...accumilator, entry.value];
      return found;
    }

    if (entry.children) {
      result = find(entry.children, number, [...accumilator, entry.value]);
    }

    if (result !== false) {
      return result;
    }
  }
  return false;
};

class CascaderComponent extends Component {
  static propTypes = {
    array: PropTypes.array.isRequired,
    valueKey: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    childrenKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    initialValue: PropTypes.number,
  };

  static defaultProps = {
    initialValue: undefined,
  }

  constructor(props) {
    super(props);
    this.state = {
      isComputed: false,
      initialValue: [],
    };
  }

  componentDidMount() {
    if (this.props.initialValue) {
      let arr = recursive(this.props.array, this.props.valueKey, this.props.labelKey, this.props.childrenKey);
      console.log(arr);
      console.log('ZZZZ', find(arr, this.props.initialValue, []));
      this.setState({
        initialValue: find(arr, this.props.initialValue, []) || [],
        isComputed: true,
      });
    } else {
      this.setState({
        isComputed: true,
      });
    }
  }

  onChange = (arr) => {
    this.props.onChange(arr[arr.length - 1] || undefined);
  }

  render() {
    const {
      valueKey, labelKey, childrenKey, array, onChange, initialValue, ...rest
    } = this.props;
    return this.state.isComputed ? (
      <Cascader
        options={recursive(array, valueKey, labelKey, childrenKey)}
        onChange={this.onChange}
        defaultValue={this.state.initialValue}
        changeOnSelect
        {...rest}
      />
    ) : null;
  }
}


// const CascaderComponent = (props) => {
//   const {
//     valueKey, labelKey, childrenKey, array, onChange, ...rest
//   } = props;

//   const onChangeFn = (arr) => {
//     onChange(arr[arr.length - 1] || undefined);
//   };

//   return (
//     <Cascader
//       options={recursive(array, valueKey, labelKey, childrenKey)}
//       onChange={onChangeFn}
//       changeOnSelect
//       {...rest}
//     />
//   );
// };

export default CascaderComponent;

/* array.map((entry) => {
  const children = entry[childrenKey].map(child => ({
    value: child[valueKey],
    label: child[labelKey],
  }));

  return {
    value: entry[valueKey],
    label: entry[labelKey],
    children,
  };
}) */



// WEBPACK FOOTER //
// ./src/components/Cascader/index.js